var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.45312 1.98438C2.4375 1 3.61719 0.507812 4.99219 0.507812C6.38281 0.507812 7.5625 1 8.53125 1.98438C9.51562 2.95312 10.0078 4.125 10.0078 5.5C10.0078 6.875 9.51562 8.05469 8.53125 9.03906C7.5625 10.0078 6.38281 10.4922 4.99219 10.4922C3.61719 10.4922 2.4375 10.0078 1.45312 9.03906C0.484375 8.05469 0 6.875 0 5.5C0 4.125 0.484375 2.95312 1.45312 1.98438ZM5.50781 8.00781V5.00781H4.5V8.00781H5.50781ZM5.50781 4V2.99219H4.5V4H5.50781Z",
    fill: "#A1B3C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.558d19222d28028b6adabd8814d486b8.svg";
export { ForwardRef as ReactComponent };